import { BrowserStorage } from './storage';

export function BrowserStorageFactory(): BrowserStorage {
  return new BrowserStorage();
}
